import React, { useState, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal";

const ConfigInterfaceProfilesHelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  actions.recv("open-help", function () {
    setOpen(true);
  });
  const doClose = () => setOpen(false);
  if (open !== true) {
    return null;
  }

  return (
    <Modal
      title="Interface Profiles"
      onClose={doClose}
      content={() => (
        <React.Fragment>
          <p>
            Interface Profiles. Match flows in which the first packet came
            through any of the specified interfaces. For subscribers, the match
            will come from the first flow in the subscriber.
          </p>
          <ul>
            <li>
              <b>NAME</b>: Profile name.
            </li>
            <li>
              <b>INPUT INTERFACES</b>: Interfaces participating in the profile.
            </li>
          </ul>
          <p>
            Click on the <i className="material-icons valign-icon">edit</i> icon
            to edit an already configured profile.
          </p>
          <p>
            Click on the <i className="material-icons valign-icon">delete</i>{" "}
            icon to delete all entries of the corresponding profile.
          </p>
          <p>
            Press the <i className="material-icons valign-icon">more_vert</i>{" "}
            icon and then select the <b>Add Profile...</b> option to /add a new
            profile.
          </p>
          <p>
            Click on the <i className="material-icons valign-icon">refresh</i>{" "}
            icon to refresh profiles information.
          </p>
        </React.Fragment>
      )}
    />
  );
};

export default ConfigInterfaceProfilesHelpModal;
